import { GetServerSideProps } from 'next'
import { ReactElement } from 'react'

import { getLoginRequest } from '@src/api'
import { acceptLoginRequest } from '@src/api/repositories/hydra-admin'
import { PresidentSigninPage } from '@src/features/_president/signin/page'
import { SigninPage } from '@src/features/signin/page'
import { useRedirectRules } from '@src/hooks'
import { SimpleLayout } from '@src/layouts/simple-layout'
import { CustomHead } from '@src/meta/head'
import { NextPageWithLayout } from '@src/pages/_app.page'
import { isPresident, isPresidentByProcessEnv } from '@src/utils'

export const Page: NextPageWithLayout = () => {
  useRedirectRules()
  return isPresident() ? <PresidentSigninPage /> : <SigninPage />
}

Page.getLayout = function getLayout(page: ReactElement) {
  return (
    <>
      <CustomHead title="ログイン" />
      <SimpleLayout>{page}</SimpleLayout>
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const loginChallenge =
    typeof context.query.login_challenge === 'string'
      ? context.query.login_challenge
      : undefined

  if (
    isPresidentByProcessEnv &&
    process.env.NODE_ENV === 'production' &&
    !!loginChallenge
  ) {
    const loginRequestResponse = await getLoginRequest(loginChallenge)
    const loginRequest = loginRequestResponse.data

    if (!loginRequest) {
      return {
        props: {},
      }
    } else if (loginRequest.skip) {
      try {
        const response = await acceptLoginRequest(loginChallenge, {
          subject: loginRequest.subject,
          remember: false,
        })
        return {
          redirect: {
            destination: response.data.redirect_to,
            permanent: false,
          },
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
        return {
          props: {},
        }
      }
    }

    return {
      props: {},
    }
  }

  return {
    props: {},
  }
}
export default Page
